import { useEffect, useState } from "react"
import { isMobile, isMobileSafari } from "react-device-detect"

import { Modal, useModal } from "~/shared/ui/kit"
import { IconButton, MaterialIcon, PopupHint } from "~/shared/ui"
import { isStandalone } from "~/shared/lib/utils"
import { breakPoints, isMobileOrStandalone } from "~/shared/ui/constants"
import { useMediaQuery } from "react-responsive"
import { actionButtonSize } from "~/templates/main/MainUserbar/style"

function InstallAppButtonIOS() {

	const [modal, setShow] = useModal(false)
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	useEffect(() => {
		if (modal.open) {
			localStorage.setItem("setting.hideInstallAppButtonIOS", "1")
		}
	}, [modal.open])

	return localStorage.getItem("setting.hideInstallAppButtonIOS") !== "1"
		? (
			<>
				<Modal
					colorStyle="primary"
					title="Установка на главный экран"
					{...modal}
					className="max-w-[30rem] m-[1rem]"
					style={{ marginTop: isMobileOrStandalone ? "20dvh" : "20vh" }}
				>
					<p>
						Чтобы установить ЭИОС на главный экран, нажмите кнопку{" "}
						<b>Поделиться</b>{" "}
						<MaterialIcon
							name="ios_share"
							style={{
								lineHeight: "normal",
								verticalAlign: "-0.2rem"
							}}
						/>{" "}
						и выберите пункт <b>На экран "Домой"</b>.
					</p>
				</Modal>
				<IconButton
					onClick={() => {
						setShow(true)
					}}
					style={{
						flex: "0 1 auto",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						color: "var(--cs-primary-dark)",
						...actionButtonSize
					}}
					iconSize={isSmallDevice ? "1.45rem" : "1.7rem"}
					transparent
					colorStyle="primary"
					borderless
					icon="install_mobile"
				/>
			</>
		)
		: null
}

let gDeferredPrompt: any = null

export function InstallAppButton() {

	const [deferredPrompt, setDeferredPrompt] = useState(gDeferredPrompt) as any
	const [show, setShow] = useState(false)
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	useEffect(() => {
		const beforeInstallPromptHandler = (e) => {
			//e.preventDefault()
			gDeferredPrompt = e
			setDeferredPrompt(e)
			setShow(true)
		}

		if (isMobileSafari) {
			if ("getInstalledRelatedApps" in window.navigator) {
				;(window.navigator.getInstalledRelatedApps as any)().then(
					(apps) => {
						if (apps.length === 0) setShow(true)
					}
				)
			} else {

				const safariStandalone = localStorage.getItem("safari_standalone") === "1"

				if (!safariStandalone) {

					if (isStandalone()) {
						localStorage.setItem("safari_standalone", "1")
					}

					setShow(true)
				}

			}
		} else {
			window.addEventListener(
				"beforeinstallprompt",
				beforeInstallPromptHandler
			)
		}

		return () => {
			if (!isMobileSafari) {
				window.removeEventListener(
					"beforeinstallprompt",
					beforeInstallPromptHandler
				)
			}
		}
	}, [])

	if (isMobileSafari) {
		return show && isStandalone() ? <InstallAppButtonIOS /> : null
	}

	return show && deferredPrompt != null ? (
		<PopupHint text="Установить как приложение" position="bottom">
			<IconButton
				onClick={async () => {
					deferredPrompt.prompt()
					const { outcome } = await deferredPrompt.userChoice
					console.log(
						`User response to the install prompt: ${outcome}`
					)
					setDeferredPrompt(null)
				}}
				style={{
					flex: "0 1 auto",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: "2rem",
					height: "2rem",
					color: "var(--cs-primary-dark)"
				}}
				iconSize={isSmallDevice ? "1.55rem" : "2rem"}
				transparent
				colorStyle="primary"
				borderless
				icon={isMobile ? "install_mobile" : "install_desktop"}
			/>
		</PopupHint>
	) : null
}
